import { Box, Paper, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import CrmDashboardTaskCard from './CrmDashboardTaskCard';
import { BADGE_SX, SURFACE_SX } from './crmDashboardStyles';

const CrmDashboardTaskSection = memo(function CrmDashboardTaskSection({
  compactEmpty = false,
  emptyMessage,
  items = [],
  title,
  tone = 'planned',
}) {
  const countBadgeSx =
    tone === 'overdue'
      ? {
          color: '#b71c1c',
          backgroundColor: 'rgba(198,40,40,0.10)',
          borderColor: 'rgba(198,40,40,0.20)',
        }
      : tone === 'today'
        ? {
            color: '#7a4b00',
            backgroundColor: 'rgba(255,193,7,0.18)',
            borderColor: 'rgba(255,193,7,0.32)',
          }
        : {
            color: 'primary.main',
            backgroundColor: 'rgba(0,121,107,0.08)',
            borderColor: 'rgba(0,121,107,0.16)',
          };

  return (
    <Paper
      elevation={0}
      sx={{
        ...SURFACE_SX,
        p: compactEmpty ? { xs: 1.5, md: 1.65 } : { xs: 1.75, md: 2 },
      }}
    >
      <Stack spacing={items.length > 0 ? 1.25 : 0.75}>
        {title && (
          <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
            <Typography variant="h6" fontWeight={700}>
              {title}
            </Typography>
            <Box component="span" sx={{ ...BADGE_SX, ...countBadgeSx }}>
              {items.length}
            </Box>
          </Stack>
        )}

        {items.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            {emptyMessage}
          </Typography>
        ) : (
          <Stack spacing={1}>
            {items.map((item) => (
              <CrmDashboardTaskCard key={item.id} item={item} />
            ))}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
});

export default CrmDashboardTaskSection;
